import type { FC } from "react";

import { AdultoAv } from "@ui/components/AdultoAv/AdultoAv";
import { AGEPROOF_INPUT_ID_SELECTOR, AgeProofAv } from "@ui/components/AgeProofAv/AgeProofAv";
import classNames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";

import styles from "./SyncAvWidgets.module.scss";

type SyncAvWidgetsProps = {
  selectedMethod: string;
  onAvFinished: (verificationId: string) => void;
};

type AvMethodsComponent = FC<{ scriptLink: string; scriptKey: string; onAvFinish: (verificationId: string) => void }>;

export const AvMethodsComponents: Partial<Record<string, AvMethodsComponent>> = {
  adulto_cz_av: AdultoAv,
  ageproof_cz_av: AgeProofAv,
};

export const getSyncAvMethodVerificationId = (method: string): string | null => {
  if (method === "ageproof_cz_av") {
    const input = document.querySelector<HTMLInputElement>(AGEPROOF_INPUT_ID_SELECTOR);

    return input?.value ?? null;
  }

  return null;
};

export const SyncAvWidgets: FC<SyncAvWidgetsProps> = ({ selectedMethod, onAvFinished }) => {
  const SyncAvComponent = AvMethodsComponents[selectedMethod];

  const config = useConfig();

  const scriptConfig = config.AGE_VERIFICATION_ASYNC_SCRIPTS_CONFIG?.find(
    (syncScriptConfig) => syncScriptConfig.code === selectedMethod
  );
  const scriptLink = scriptConfig?.scriptUrl;
  const scriptKey = scriptConfig?.scriptKey;
  const isComponentShown = SyncAvComponent && scriptLink && scriptKey;

  return (
    <div
      className={classNames({
        [styles.hiddenComponent]: !isComponentShown,
      })}
      data-testid="syncAvWidget"
    >
      {isComponentShown && <SyncAvComponent scriptLink={scriptLink} scriptKey={scriptKey} onAvFinish={onAvFinished} />}
    </div>
  );
};
